import InvoiceService from './services';
import GetAllInvoiceUseCase from './use-cases/GetAllInvoices';
import GetInvoiceByIdUseCase from './use-cases/GetInvoiceById';
import AbstractModuleFactory from '@core/shared/module-factory';
import DownloadInvoiceByIdUseCase from './use-cases/DownloadInvoiceById';
import SendSelectedInvoiceToEmailUseCase from './use-cases/SendSelectedInvoiceToEmail';

export class InvoiceModuleFactory extends AbstractModuleFactory {
  createGetAllInvoicesUseCase(): GetAllInvoiceUseCase {
    return this.ensureInstance('GetAllInvoiceUseCase', () => new GetAllInvoiceUseCase());
  }

  creatGetInvoiceByIdUseCase(): GetInvoiceByIdUseCase {
    return this.ensureInstance('GetInvoiceByIdUseCase', () => new GetInvoiceByIdUseCase(new InvoiceService()));
  }

  creatDownloadInvoiceByIdUseCase(): DownloadInvoiceByIdUseCase {
    return this.ensureInstance('DownloadInvoiceByIdUseCase', () => new DownloadInvoiceByIdUseCase(new InvoiceService()));
  }

  createSendInvoicesToEmailUseCase(): SendSelectedInvoiceToEmailUseCase {
    return this.ensureInstance('SendSelectedInvoiceToEmailUseCase', () => new SendSelectedInvoiceToEmailUseCase());
  }

  static new(): InvoiceModuleFactory {
    return new InvoiceModuleFactory();
  }
}

export default InvoiceModuleFactory.new();
